<template>
  <div class="main_div" :key="componentKey">
    <div style="height: auto">
      <n-space>
        <NCard style="margin-top: 20px; margin-left: 80px; border: 0px; min-width: 800px">
          <n-space item-style="display: flex;" align="center">
            <div style="font-size: 20px; width: 150px; font-weight: bold">기관 관리</div>
          </n-space>
          <div class="content_delimiter_line"></div>
          <Loading v-show="loading" />
          <button @click="goToRegisterOrganization" class="action-button">신규 기관 등록</button>
          <n-tabs
            type="line"
            animated
            v-model:value="currentTab"
            @update:value="handleTabChange"
            style="margin-top: 10px"
          >
            <n-tab-pane :name="TAB.PENDING" :disabled="listLoading">
              <template #tab>
                <n-space align="center" :size="8" :wrap-item="false">
                  <span>등록 요청</span>
                  <n-spin v-if="listLoading && currentTab === TAB.PENDING" size="small" />
                </n-space>
              </template>
              <n-space vertical style="margin-top: 10px">
                <n-space align="baseline" item-style="display: flex;">
                  <n-form-item label="검색" style="min-width: 350px" label-placement="left">
                    <n-input-group>
                      <n-select v-model:value="searchTypeForPending" :options="searchOptions" style="width: 120px" />
                      <n-input v-model:value="searchValueForPending" placeholder="검색어를 입력하세요" clearable />
                    </n-input-group>
                  </n-form-item>
                  <n-form-item style="min-width: 300px" label-placement="left"> </n-form-item>
                  <n-form-item style="margin-bottom: 0">
                    <n-button type="primary" @click="wrappedRefreshOrganizations({ status: TAB.PENDING })">
                      조회
                    </n-button>
                  </n-form-item>
                </n-space>
              </n-space>
              <br />
              <div>
                <div v-if="listLoading" class="loading-indicator">기관 등록 요청 목록을 불러오는 중...</div>
                <div v-else-if="error" class="error-message">{{ error }}</div>
                <div v-else>
                  <div class="table-container">
                    <n-data-table
                      v-if="pendingOrgs.length > 0"
                      :columns="requestColumns"
                      :data="pendingOrgs"
                      :pagination="false"
                      :bordered="true"
                    />
                    <p v-else>등록된 기관 등록 요청이 없습니다.</p>
                  </div>
                  <div
                    v-if="pendingOrgs.length > 0"
                    class="pagination-controls"
                    style="margin-top: 15px; text-align: center"
                  >
                    <n-button @click="wrappedGoToPreviousPage" :disabled="currentPage === 1" style="margin-right: 8px">
                      이전 페이지
                    </n-button>
                    <span style="margin: 0 10px">{{ currentPage }} 페이지</span>
                    <n-button @click="wrappedGoToNextPage" :disabled="!hasNextPage"> 다음 페이지 </n-button>
                  </div>
                </div>
              </div>
            </n-tab-pane>
            <n-tab-pane :name="TAB.APPROVED" :disabled="listLoading">
              <template #tab>
                <n-space align="center" :size="8" :wrap-item="false">
                  <span>승인된 기관</span>
                  <n-spin v-if="listLoading && currentTab === TAB.APPROVED" size="small" />
                </n-space>
              </template>
              <n-space vertical style="margin-top: 10px">
                <n-space align="baseline" item-style="display: flex;">
                  <n-form-item label="검색" style="min-width: 350px" label-placement="left">
                    <n-input-group>
                      <n-select v-model:value="searchTypeForAccepted" :options="searchOptions" style="width: 120px" />
                      <n-input v-model:value="searchValueForAccepted" placeholder="검색어를 입력하세요" clearable />
                    </n-input-group>
                  </n-form-item>
                  <n-form-item style="min-width: 300px" label-placement="left"> </n-form-item>
                  <n-form-item style="margin-bottom: 0">
                    <n-button type="primary" @click="wrappedRefreshOrganizations({ status: TAB.APPROVED })">
                      조회
                    </n-button>
                  </n-form-item>
                </n-space>
              </n-space>
              <br />
              <div>
                <div v-if="listLoading" class="loading-indicator">기관 목록을 불러오는 중...</div>
                <div v-else-if="error" class="error-message">{{ error }}</div>
                <div v-else>
                  <div class="table-container">
                    <n-data-table
                      v-if="approvedOrgs.length > 0"
                      :columns="columns"
                      :data="approvedOrgs"
                      :pagination="false"
                      :bordered="true"
                    />
                    <p v-else>등록된 기관이 없습니다.</p>
                  </div>
                  <div
                    v-if="approvedOrgs.length > 0"
                    class="pagination-controls"
                    style="margin-top: 15px; text-align: center"
                  >
                    <n-button @click="wrappedGoToPreviousPage" :disabled="currentPage === 1" style="margin-right: 8px">
                      이전 페이지
                    </n-button>
                    <span style="margin: 0 10px">{{ currentPage }} 페이지</span>
                    <n-button @click="wrappedGoToNextPage" :disabled="!hasNextPage"> 다음 페이지 </n-button>
                  </div>
                </div>
              </div>
            </n-tab-pane>
          </n-tabs>
        </NCard>

        <n-modal
          v-model:show="showDetailsModal"
          preset="card"
          style="width: 800px"
          title="기관 상세 정보"
          @after-leave="onDetailsModalClose"
        >
          <div v-if="selectedOrganization" class="organization-details-content">
            <!-- <n-form ref="detailsFormRef"> Potentially for future validation -->
            <n-descriptions label-placement="left" bordered :column="2" size="small" class="compact-descriptions">
              <n-descriptions-item label="기관 ID" :span="2">
                <n-form-item :show-label="false" style="margin-bottom: 0">
                  {{
                    selectedOrganization.SK && selectedOrganization.SK.includes("#")
                      ? selectedOrganization.SK.split("#")[1]
                      : selectedOrganization.SK
                  }}
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="기관명" :span="2">
                <n-form-item path="name" :show-label="false" style="margin-bottom: 0">
                  <n-input v-model:value="editableOrganizationDetails.name" placeholder="기관 전체 이름" />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="대표자 이름" :span="2">
                <n-form-item path="president" :show-label="false" style="margin-bottom: 0">
                  <n-input v-model:value="editableOrganizationDetails.president" placeholder="대표자 이름" />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="기관 유형" :span="2">
                <n-form-item path="type" :show-label="false" style="margin-bottom: 0">
                  <n-select
                    v-model:value="editableOrganizationDetails.type"
                    placeholder="기관 유형 선택"
                    :options="typeOptions"
                  />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="우편번호" :span="2">
                <n-form-item path="address.postCode" :show-label="false" style="margin-bottom: 0">
                  <n-input v-model:value="editableOrganizationDetails.address.postCode" placeholder="우편번호" />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="주소" :span="2">
                <n-form-item path="address.address" :show-label="false" style="margin-bottom: 0">
                  <n-input v-model:value="editableOrganizationDetails.address.address" placeholder="주소" />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="상세주소" :span="2">
                <n-form-item path="address.addressDetail" :show-label="false" style="margin-bottom: 0">
                  <n-input v-model:value="editableOrganizationDetails.address.addressDetail" placeholder="상세주소" />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="담당부서">
                <n-form-item path="dept" :show-label="false" style="margin-bottom: 0">
                  <n-input v-model:value="editableOrganizationDetails.dept" placeholder="담당부서 이름" />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="전화번호">
                <n-form-item path="phoneNumber" :show-label="false" style="margin-bottom: 0">
                  <n-input
                    v-model:value="editableOrganizationDetails.phoneNumber"
                    placeholder="대표 전화번호 (예: 02-123-4567)"
                  />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="담당자 이름">
                <n-form-item path="deptPersonName" :show-label="false" style="margin-bottom: 0">
                  <n-input v-model:value="editableOrganizationDetails.deptPersonName" placeholder="담당자 이름" />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="이메일">
                <n-form-item path="email" :show-label="false" style="margin-bottom: 0">
                  <n-input v-model:value="editableOrganizationDetails.email" placeholder="대표 이메일 주소" />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="설명" :span="2">
                <n-form-item path="description" :show-label="false" style="margin-bottom: 0">
                  <n-input
                    v-model:value="editableOrganizationDetails.description"
                    type="textarea"
                    placeholder="기관에 대한 간략한 설명 (선택 사항)"
                  />
                </n-form-item>
              </n-descriptions-item>
            </n-descriptions>

            <div v-if="selectedOrganization.admin" style="margin-top: 20px">
              <h4 class="details-subtitle">관리자 정보</h4>
              <n-descriptions label-placement="left" bordered :column="1" size="small" class="admin-details-table">
                <n-descriptions-item>
                  <template #label>
                    <div class="description-item-label-fixed-width">기관 관리자 ID</div>
                  </template>
                  <div class="description-item-content-flex">
                    <span>
                      {{
                        selectedOrganization.admin.SK && selectedOrganization.admin.SK.includes("#")
                          ? selectedOrganization.admin.SK.split("#")[2] // "org#id#admin" -> "admin"
                          : selectedOrganization.admin.SK
                      }}
                    </span>
                    <n-button
                      size="small"
                      type="warning"
                      ghost
                      @click="resetOrgAdminPassword(selectedOrganization.SK)"
                      style="margin-left: auto"
                      >비밀번호 재설정</n-button
                    >
                  </div>
                </n-descriptions-item>
              </n-descriptions>
            </div>
            <div style="text-align: right; margin-top: 20px">
              <n-button @click="closeDetailsModal" type="tertiary" style="margin-right: 10px">취소</n-button>
              <n-button @click="handleUpdateOrganization" type="primary" :loading="isUpdating">수정</n-button>
            </div>
          </div>
          <!-- </n-form> -->
        </n-modal>

        <!-- 신규 기관 등록 폼/모달을 위한 플레이스홀더 -->
        <n-modal v-model:show="showRegistrationForm" preset="card" style="width: 800px" title="신규 기관 등록">
          <div class="registration-modal-content-scrollable">
            <n-form
              ref="registrationFormRef"
              :model="registrationModel"
              :rules="registrationRules"
              label-placement="left"
              require-mark-placement="right-hanging"
            >
              <n-descriptions label-placement="left" bordered :column="2" size="small" class="compact-descriptions">
                <n-descriptions-item label="기관 ID" :span="2">
                  <n-form-item path="uid" :show-label="false" style="margin-bottom: 0">
                    <n-input-group>
                      <n-input v-model:value="registrationModel.uid" placeholder="영문, 숫자 조합 (예: coko)" />
                      <n-button type="primary" ghost @click="checkOrganizationId" :loading="isCheckingId"
                        >중복 체크</n-button
                      >
                    </n-input-group>
                    <div
                      v-if="idCheckMessage"
                      :class="isIdAvailable ? 'success-message' : 'error-message'"
                      style="font-size: 0.9em; margin-top: 4px"
                    >
                      {{ idCheckMessage }}
                    </div>
                  </n-form-item>
                </n-descriptions-item>
                <n-descriptions-item label="기관명" :span="2">
                  <n-form-item path="name" :show-label="false" style="margin-bottom: 0">
                    <n-input v-model:value="registrationModel.name" placeholder="기관 전체 이름" />
                  </n-form-item>
                </n-descriptions-item>
                <n-descriptions-item label="대표자 이름" :span="2">
                  <n-form-item path="president" :show-label="false" style="margin-bottom: 0">
                    <n-input v-model:value="registrationModel.president" placeholder="대표자 이름" />
                  </n-form-item>
                </n-descriptions-item>
                <n-descriptions-item label="기관 유형" :span="2">
                  <n-form-item path="type" :show-label="false" style="margin-bottom: 0">
                    <n-select
                      v-model:value="registrationModel.type"
                      placeholder="기관 유형 선택"
                      :options="typeOptions"
                    />
                  </n-form-item>
                </n-descriptions-item>
                <n-descriptions-item label="우편번호" :span="2">
                  <n-form-item path="address.postCode" :show-label="false" style="margin-bottom: 0">
                    <n-input-group>
                      <n-input
                        v-model:value="registrationModel.address.postCode"
                        placeholder="우편번호"
                        style="width: 120px"
                        :disabled="true"
                        class="force-black-text-disabled"
                      />
                      <n-button
                        type="primary"
                        ghost
                        @click="openPostcodeSearch"
                        size="small"
                        style="margin-left: 5px !important"
                      >
                        주소검색
                      </n-button>
                    </n-input-group>
                  </n-form-item>
                </n-descriptions-item>
                <n-descriptions-item label="주소" :span="2">
                  <n-form-item path="address.address" :show-label="false" style="margin-bottom: 0">
                    <n-input
                      v-model:value="registrationModel.address.address"
                      placeholder="주소"
                      :disabled="true"
                      class="force-black-text-disabled"
                    />
                  </n-form-item>
                </n-descriptions-item>
                <n-descriptions-item label="상세주소" :span="2">
                  <n-form-item path="address.addressDetail" :show-label="false" style="margin-bottom: 0">
                    <n-input
                      id="addressDetailInput"
                      v-model:value="registrationModel.address.addressDetail"
                      placeholder="상세주소"
                      class="force-black-text-disabled"
                    />
                  </n-form-item>
                </n-descriptions-item>
                <n-descriptions-item label="담당부서">
                  <n-form-item path="dept" :show-label="false" style="margin-bottom: 0">
                    <n-input v-model:value="registrationModel.dept" placeholder="담당부서 이름" />
                  </n-form-item>
                </n-descriptions-item>
                <n-descriptions-item label="전화번호">
                  <n-form-item path="phoneNumber" :show-label="false" style="margin-bottom: 0">
                    <n-input
                      v-model:value="registrationModel.phoneNumber"
                      placeholder="대표 전화번호 (예: 02-123-4567)"
                    />
                  </n-form-item>
                </n-descriptions-item>
                <n-descriptions-item label="담당자 이름">
                  <n-form-item path="deptPersonName" :show-label="false" style="margin-bottom: 0">
                    <n-input v-model:value="registrationModel.deptPersonName" placeholder="담당자 이름" />
                  </n-form-item>
                </n-descriptions-item>
                <n-descriptions-item label="담당자 연락처">
                  <n-form-item path="deptPersonPhoneNumber" :show-label="false" style="margin-bottom: 0">
                    <n-input v-model:value="registrationModel.deptPersonPhoneNumber" placeholder="담당자 연락처" />
                  </n-form-item>
                </n-descriptions-item>
                <n-descriptions-item label="담당자 이메일" :span="2">
                  <n-form-item path="email" :show-label="false" style="margin-bottom: 0">
                    <n-input v-model:value="registrationModel.email" placeholder="대표 이메일 주소" />
                  </n-form-item>
                </n-descriptions-item>
                <n-descriptions-item label="설명" :span="2">
                  <n-form-item path="description" :show-label="false" style="margin-bottom: 0">
                    <n-input
                      v-model:value="registrationModel.description"
                      type="textarea"
                      placeholder="기관에 대한 간략한 설명 (선택 사항)"
                    />
                  </n-form-item>
                </n-descriptions-item>
              </n-descriptions>
            </n-form>
          </div>
          <!-- The div below was empty and is removed. Buttons are correctly outside the form but inside the modal. -->
          <!-- <div class="registration-form-content"> -->
          <div style="text-align: right; margin-top: 20px">
            <n-button @click="showRegistrationForm = false" type="tertiary" style="margin-right: 10px">취소</n-button>
            <n-button type="primary" :loading="isRegisting" @click="handleRegistrationSubmit">등록</n-button>
          </div>
        </n-modal>

        <!-- 사용자 관리 목록 모달 -->
        <n-modal
          v-model:show="showUserManagementModal"
          preset="card"
          style="width: 1000px; max-width: 95vw; max-height: 85vh;"
          :title="selectedOrgForUserManagement ? `사용자 관리 - ${selectedOrgForUserManagement.name}` : '사용자 관리'"
        >
          <n-space vertical :size="12">
            <div style="text-align: right;">
              <n-button type="primary" @click="openAddUserForm">사용자 추가</n-button>
            </div>
            <div v-if="loadingOrgMembers" style="text-align: center; padding: 20px;">
              <n-spin size="medium" />
              <div style="margin-top: 8px;">사용자 목록을 불러오는 중...</div>
            </div>
            <div v-else>
              <n-data-table
                :columns="userTableColumns"
                :data="orgMembers"
                :pagination="{ pageSize: 5 }"
                :bordered="true"
              />
            </div>
          </n-space>
        </n-modal>

        <!-- 사용자 추가/수정 모달 -->
        <n-modal
          v-model:show="showUserEditModal"
          preset="card"
          style="width: 600px; max-width: 90vw;"
          :title="isEditingUser ? '사용자 정보 수정' : '사용자 추가'"
          :closable="!isSavingUser"
          :mask-closable="!isSavingUser"
        >
          <n-space vertical :size="12">
            <n-alert v-if="isEditingUser" type="warning" title="주의 사항" style="margin-bottom: 10px">
              사용자 정보를 수정하더라도 이미 이 사용자가 담당자로 지정된 기존 진단 정보(학급 정보 등)에는 자동으로 반영되지 않습니다.
              기존 진단의 담당자 정보도 함께 업데이트하려면, 해당 진단의 상세 화면에서 '담당자 변경' 기능을 사용하여 재설정해 주시기 바랍니다.
            </n-alert>
            <n-form
              ref="userEditFormRef"
              :model="userEditFormData"
              :rules="userEditFormRules"
              label-placement="left"
              label-width="100"
            >
              <n-form-item path="uid" label="아이디">
                <n-input v-model:value="userEditFormData.uid" placeholder="아이디를 입력해주세요" :disabled="isEditingUser || isSavingUser" />
              </n-form-item>
              <n-form-item v-if="!isEditingUser" path="password" label="암호">
                <n-input v-model:value="userEditFormData.password" type="password" placeholder="암호를 입력해주세요" show-password-on="mousedown" :disabled="isSavingUser" />
              </n-form-item>
              <n-form-item v-if="!isEditingUser" path="confirmPassword" label="암호 확인">
                <n-input v-model:value="userEditFormData.confirmPassword" type="password" placeholder="암호를 다시 입력해주세요" show-password-on="mousedown" :disabled="isSavingUser" />
              </n-form-item>
              <n-form-item path="name" label="이름">
                <n-input v-model:value="userEditFormData.name" placeholder="이름을 입력해주세요" :disabled="isSavingUser" />
              </n-form-item>
              <n-form-item path="email" label="이메일">
                <n-input v-model:value="userEditFormData.email" placeholder="이메일을 입력해주세요" :disabled="isSavingUser" />
              </n-form-item>
              <n-form-item label="전화번호">
                <n-input v-model:value="userEditFormData.phoneNumber" placeholder="전화번호를 입력해주세요" :disabled="isSavingUser" />
              </n-form-item>
              <n-form-item label="구분">
                <n-select
                  v-model:value="userEditFormData.type"
                  :options="[
                    { label: '일반사용자', value: 'user' },
                    { label: '관리자', value: 'admin' }
                  ]"
                  :disabled="isSavingUser"
                />
              </n-form-item>
              <n-form-item label="역할">
                <n-input v-model:value="userEditFormData.role" placeholder="역할을 입력해주세요 (예: 교사, 강사)" :disabled="isSavingUser" />
              </n-form-item>
              <n-form-item label="직책">
                <n-input v-model:value="userEditFormData.position" placeholder="직책을 입력해주세요 (예: 담임, 주임)" :disabled="isSavingUser" />
              </n-form-item>
              <n-form-item label="설명">
                <n-input
                  v-model:value="userEditFormData.description"
                  type="textarea"
                  placeholder="설명을 입력해주세요"
                  :disabled="isSavingUser"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                />
              </n-form-item>
            </n-form>
            <div style="text-align: right; margin-top: 15px">
              <n-button :disabled="isSavingUser" @click="showUserEditModal = false" style="margin-right: 8px">취소</n-button>
              <n-button type="primary" :loading="isSavingUser" @click="handleUserEditSubmit">저장</n-button>
            </div>
          </n-space>
        </n-modal>
      </n-space>

    </div>
  </div>
</template>

<script setup lang="ts">
import { Organization, OrgUserBase, OrganizationType } from "@/model/organization";
import { ref, onMounted, h, computed } from "vue";
import { getCallable } from "@/config/env";
import {
  NSpace,
  NCard,
  NButton,
  NDataTable,
  NModal,
  NSelect,
  NDescriptions,
  NDescriptionsItem,
  useMessage,
  NTabs,
  NTabPane,
  useNotification,
  useDialog,
  DataTableColumns,
  NForm,
  NInput,
  NInputGroup,
  FormInst,
  FormRules,
  NIcon,
  NSpin,
  NFormItem, // Ensure NFormItem is imported if it wasn't explicitly for direct use
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import * as common from "@/assets/common/common";
import { useAuth } from "@/composables/useAuth";
import { QueryInfo } from "@/model/common";
import { usePagination } from "@/composables/usePagination";
import { USER_ROUTES } from "@/assets/route_constants";
import { useActionDialog } from "@/composables/useDialog";
const { show: showActionDialog } = useActionDialog();
const { isLoggedIn, loading } = useAuth();

const TAB = {
  PENDING: "pending",
  APPROVED: "approved",
};

const currentTab = ref("pending");
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const router = useRouter();
const createOrganizationCallable = getCallable("createOrganization");
const updateOrganizationCallable = getCallable("updateOrganization");
const getOrgsCallable = getCallable("getOrgs");
const getOrgRequestsCallable = getCallable("getOrgRequests");
const approveOrganizationRequestCallable = getCallable("approveOrganizationRequest");
const rejectOrganizationRequestCallable = getCallable("rejectOrganizationRequest");
const getOrgInfoCallable = getCallable("getOrgInfo");
const resetOrgAdminPasswordCallable = getCallable("resetOrgAdminPassword");
const checkOrgIdCallable = getCallable("checkOrgId");

// 사용자 관리 관련 Callable
const getOrgMembersCallable = getCallable("getOrgMembers");
const addOrgUserCallable = getCallable("addOrgUser");
const deleteOrgUserMemberCallable = getCallable("deleteOrgUserMember");
const updateOrgUserCallable = getCallable("updateOrgUser");


const searchValueForPending = ref<string | null>(null);
const searchTypeForPending = ref("name");
const searchValueForAccepted = ref<string | null>(null);
const searchTypeForAccepted = ref("name");

// 사용자 관리 모달 관련 상태
const showUserManagementModal = ref(false);
const selectedOrgForUserManagement = ref<Organization | null>(null);
const orgMembers = ref<any[]>([]);
const loadingOrgMembers = ref(false);

// 사용자 추가/수정 모달 관련 상태
const showUserEditModal = ref(false);
const isEditingUser = ref(false); // true: 수정, false: 추가
const userEditFormRef = ref<FormInst | null>(null);
const isSavingUser = ref(false);
const userEditFormData = ref({
  orgId: "",
  uid: "",
  password: "",
  confirmPassword: "",
  name: "",
  email: "",
  phoneNumber: "",
  role: "",
  position: "",
  description: "",
  type: "user", // 기본값: 일반사용자
});

const userEditFormRules = computed(() => {
  const rules: any = {
    name: [
      { required: true, message: "이름을 입력해주세요", trigger: "blur" }
    ],
    email: [
      {
        type: "email",
        message: "올바른 이메일 형식이 아닙니다",
        trigger: ["input", "blur"],
      }
    ]
  };

  if (!isEditingUser.value) {
    rules.uid = [
      { required: true, message: "아이디를 입력해주세요", trigger: "blur" }
    ];
    rules.password = [
      { required: true, message: "암호를 입력해주세요", trigger: "blur" }
    ];
    rules.confirmPassword = [
      {
        required: true,
        validator: (rule: any, value: string) => {
          if (!value) {
            return new Error("암호 확인을 입력해주세요");
          }
          if (value !== userEditFormData.value.password) {
            return new Error("암호가 일치하지 않습니다");
          }
          return true;
        },
        trigger: ["blur", "input"]
      }
    ];
  }
  return rules;
});


const searchOptions = [
  { label: "기관명", value: "name" },
  { label: "담당자이름", value: "deptPersonName" },
  { label: "이메일", value: "email" },
  { label: "전화번호", value: "phoneNumber" },
];

const {
  paginatedItems: organizations,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshOrganizations,
} = usePagination<Organization, { status?: string }>(
  async (params) => getOrganizationByStatus(params),
  25, // 페이지 크기
  { status: currentTab.value }
);

const getOrganizationByStatus = async (params: any) => {
  if (params.status == TAB.PENDING) {
    if (searchValueForPending.value && searchValueForPending.value.trim() !== "") {
      params.searchKey = searchTypeForPending.value;
      params.searchValue = searchValueForPending.value.trim();
    }

    return await getOrgRequestsCallable(params);
  } else if (params.status == TAB.APPROVED) {
    if (searchValueForAccepted.value && searchValueForAccepted.value.trim() !== "") {
      params.searchKey = searchTypeForAccepted.value;
      params.searchValue = searchValueForAccepted.value.trim();
    }

    return await getOrgsCallable(params);
  } else {
    return [];
  }
};

async function wrappedRefreshOrganizations(newFilters?: { status?: string }) {
  await composableRefreshOrganizations(newFilters);
}

const selectedOrganization = ref<Organization | null>(null);
const showRegistrationForm = ref<boolean>(false);
const showDetailsModal = ref<boolean>(false);
const componentKey = ref(0);
const isCheckingId = ref<boolean>(false);
const editableOrganizationDetails = ref<Partial<Organization>>({});
const typeOptions = ref([
  {
    label: "초등학교",
    value: OrganizationType.ElementarySchool,
  },
  { label: "중학교", value: OrganizationType.MiddleSchool },
  { label: "고등학교", value: OrganizationType.HighSchool },
  { label: "대학교", value: OrganizationType.University },
  { label: "기타 기관(법인/재단 등)", value: OrganizationType.Etc },
]);

const registrationFormRef = ref<FormInst | null>(null);
const registrationModel = ref<Partial<Organization>>({
  uid: "",
  name: "",
  president: "",
  address: {
    postCode: "",
    address: "",
    addressDetail: "",
  },
  dept: "",
  deptPersonName: "",
  deptPersonPhoneNumber: "",
  email: "",
  phoneNumber: "",
  description: "",
  type: null,
});
const idCheckMessage = ref<string>("");
const isIdAvailable = ref<boolean | null>(null);
const isRegisting = ref(false);
const isUpdating = ref(false);
const isApproving = ref<{ [key: string]: boolean }>({});
const isRejecting = ref<{ [key: string]: boolean }>({});

const registrationRules: FormRules = {
  uid: [{ required: true, message: "기관 ID를 입력해주세요.", trigger: ["input", "blur"] }],
  name: [{ required: true, message: "기관명을 입력해주세요.", trigger: ["input", "blur"] }],
  president: [{ required: true, message: "대표자 이름을 입력해주세요.", trigger: ["input", "blur"] }],
  dept: [{ required: true, message: "담당부서를 입력해주세요.", trigger: ["input", "blur"] }],
  deptPersonName: [{ required: true, message: "담당자 이름을 입력해주세요.", trigger: ["input", "blur"] }],
  deptPersonPhoneNumber: [{ required: true, message: "담당자 연락처를 입력해주세요.", trigger: ["input", "blur"] }],
  email: [
    { required: true, message: "이메일을 입력해주세요.", trigger: ["input", "blur"] },
    { type: "email", message: "올바른 이메일 형식이 아닙니다.", trigger: ["blur"] },
  ],
  phoneNumber: [
    { required: true, message: "전화번호를 입력해주세요.", trigger: ["input", "blur"] },
    {
      pattern: /^\d{2,3}-\d{3,4}-\d{4}$/,
      message: "전화번호 형식이 올바르지 않습니다. (예: 02-123-4567 또는 010-1234-5678)",
      trigger: ["blur"],
    },
  ],
  type: [{ required: true, message: "기관 유형을 선택해주세요.", trigger: "change" }],
};

const pendingOrgs = computed(() => {
  return organizations.value;
});

const approvedOrgs = computed(() => {
  return organizations.value;
});

function getTypeString(type: OrganizationType | null): string {
  switch (type) {
    case OrganizationType.ElementarySchool:
      return "초등학교";
      break;
    case OrganizationType.MiddleSchool:
      return "중학교";
      break;
    case OrganizationType.HighSchool:
      return "고등학교";
      break;
    case OrganizationType.University:
      return "대학교";
      break;
    case OrganizationType.Etc:
      return "기타 기관(법인/재단 등)";
      break;
    default:
      return "N/A";
  }
}

const baseColumns = [
  {
    title: "기관 ID",
    key: "SK",
    resizable: true,
    render(row: Organization) {
      if (row.SK && row.SK.includes("#")) {
        return row.SK.split("#")[1];
      }
      return row.SK;
    },
  },
  {
    title: "기관명",
    key: "name",
    resizable: true,
  },
  {
    title: "기관유형",
    key: "type",
    resizable: true,
    render(row: Organization) {
      return getTypeString(row.type);
    },
  },
  {
    title: "담당부서",
    key: "dept",
    resizable: true,
  },
  {
    title: "담당자이름",
    key: "deptPersonName",
    resizable: true,
  },
  {
    title: "이메일",
    key: "email",
    resizable: true,
  },
  {
    title: "전화번호",
    key: "phoneNumber",
    resizable: true,
  },
  {
    title: "등록일",
    key: "createdDate",
    resizable: true,
    render(row: Organization) {
      return common.getYYYYMMDD2(Number(row.createdDate));
    },
  },
  {
    title: "상세보기",
    key: "actions",
    render(row: Organization) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          onClick: () => displayOrganizationDetails(row),
        },
        { default: () => "상세" }
      );
    },
  },
];

const requestColumns = [
  ...baseColumns,
  {
    title: "승인",
    key: "actions",
    render(row: Organization) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          loading: isApproving.value[row.SK],
          onClick: () => approvedOrgRequest(row),
        },
        { default: () => "승인" }
      );
    },
  },
  {
    title: "거부",
    key: "actions",
    render(row: Organization) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          type: "error",
          size: "small",
          loading: isRejecting.value[row.SK],
          onClick: () => rejectOrgRequest(row),
        },
        { default: () => "거부" }
      );
    },
  },
];

const userTableColumns = [
  {
    title: "아이디",
    key: "userId",
    render(row: any) {
      return row.SK.split("#").pop() || "";
    }
  },
  {
    title: "이름",
    key: "name",
  },
  {
    title: "이메일",
    key: "email",
    render(row: any) {
      return row.email || "-";
    }
  },
  {
    title: "전화번호",
    key: "phoneNumber",
    render(row: any) {
      return row.phoneNumber || "-";
    }
  },
  {
    title: "구분",
    key: "type",
    render(row: any) {
      return row.type === "admin" ? "관리자" : "일반사용자";
    }
  },
  {
    title: "역할",
    key: "role",
    render(row: any) {
      return row.role || "-";
    }
  },
  {
    title: "직책",
    key: "position",
    render(row: any) {
      return row.position || "-";
    }
  },
  {
    title: "조작",
    key: "actions",
    render(row: any) {
      return h(NSpace, {}, {
        default: () => [
          h(
            NButton,
            {
              size: "small",
              type: "primary",
              onClick: () => openEditUserForm(row),
            },
            { default: () => "수정" }
          ),
          h(
            NButton,
            {
              size: "small",
              type: "error",
              onClick: () => handleDeleteUser(row),
            },
            { default: () => "삭제" }
          )
        ]
      });
    }
  }
];

const columns = [
  ...baseColumns,
  {
    title: "사용자 관리",
    key: "user_management",
    render(row: Organization) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          onClick: () => openUserManagementModal(row),
        },
        { default: () => "사용자 관리" }
      );
    },
  },
  {
    title: "견적서 작성",
    key: "actions",
    render(row: Organization) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          onClick: () => goToRegisterOrder(row.SK),
        },
        { default: () => "견적서 발행" }
      );
    },
  },
];


async function wrappedGoToNextPage() {
  if (hasNextPage.value) {
    await composableGoToNextPage();
  }
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value > 1) {
    await composableGoToPreviousPage();
  }
}

async function fetchOrganizationDetails(orgSK: string) {
  loading.value = true;
  error.value = null;
  try {
    const result = await getOrgInfoCallable({ SK: orgSK });
    const data = common.getItemFromFunctionResult(result);
    if (data) {
      const org: Organization = data as Organization; // Type assertion
      selectedOrganization.value = org;
      editableOrganizationDetails.value = {
        SK: org.SK,
        uid: org.uid,
        address: {
          postCode: org.address?.postCode || "",
          address: org.address?.address || "",
          addressDetail: org.address?.addressDetail || "",
        },
        name: org.name,
        president: org.president,
        type: org.type,
        dept: org.dept || "",
        deptPersonName: org.deptPersonName || "",
        deptPersonPhoneNumber: org.deptPersonPhoneNumber || "",
        email: org.email,
        phoneNumber: org.phoneNumber,
        description: org.description || "",
      };
      showDetailsModal.value = true;
    } else {
      throw new Error("해당 ID의 기관을 찾을 수 없습니다.");
    }
  } catch (err: any) {
    console.error(`기관 상세 정보 로딩 실패 (SK: ${orgSK}):`, err);
    error.value = `기관(SK: ${orgSK}) 상세 정보를 불러오는데 실패했습니다.`;
    selectedOrganization.value = null;
  } finally {
    loading.value = false;
  }
}

function displayOrganizationDetails(org: Organization) {
  showRegistrationForm.value = false;
  fetchOrganizationDetails(org.SK);
}

function goToRegisterOrder(orgSK: string) {
  router.push({ name: USER_ROUTES.OrgOrderRegister.Name, params: { SK: orgSK }, query: { origin: "Organization" } });
}

function closeDetailsModal() {
  showDetailsModal.value = false;
}
function onDetailsModalClose() {
  selectedOrganization.value = null;
  editableOrganizationDetails.value = {}; // Reset editable form data
}

async function approvedOrgRequest(org: Organization) {
  showActionDialog({
    title: "기관 등록 요청 승인 확인",
    content: `기관(${org.name}) 등록 요청을 승인하시겠습니까?\n승인 후 관리자 정보는 기관 이메일로 전송됩니다.`,
    positiveText: "확인",
    negativeText: "취소",
    confirmButtonLoadingText: "승인 중...",
    onConfirm: async () => {
      isApproving.value[org.SK] = true;
      try {
        const result = await approveOrganizationRequestCallable(org);
        if (common.evalFunctionResult(result)) {
          message.success("기관 등록 요청 승인이 완료되었습니다. 관리자 정보는 기관 이메일로 발송됩니다.");
          await wrappedRefreshOrganizations({ status: currentTab.value }); // Refresh the list
        } else {
          notification.error({
            title: "기관 등록 요청 승인 오류",
            content: `기관 등록 요청 승인 중 오류가 발생했습니다. ${common.getResultMessage(result)}`,
            duration: 3000,
          });
        }
      } catch (error: any) {
        console.error("기관 등록 요청 승인 실패:", error);
        notification.error({
          title: "기관 등록 요청 승인 실패",
          content: `기관 등록 요청 승인 중 오류가 발생했습니다: ${error.message || error}`,
          duration: 3000,
        });
      } finally {
        isApproving.value[org.SK] = false;
      }
    },
  });
}
async function rejectOrgRequest(org: Organization) {
  showActionDialog({
    title: "기관 등록 요청 거부 확인",
    content: `기관(${org.name}) 등록 요청을 거부하시겠습니까?\n기관 이메일로 거부 되었음을 통보합니다.`,
    positiveText: "확인",
    negativeText: "취소",
    confirmButtonLoadingText: "거부 중...",
    onConfirm: async () => {
      isRejecting.value[org.SK] = true;
      try {
        const result = await rejectOrganizationRequestCallable(org);
        if (common.evalFunctionResult(result)) {
          message.success("기관 등록 요청 거부가 완료되었습니다. 기관 이메일로 거부 되었음을 통보합니다.");
          await wrappedRefreshOrganizations({ status: currentTab.value }); // Refresh the list
        } else {
          notification.error({
            title: "기관 등록 요청 거부 오류",
            content: `기관 등록 요청 거부 중 오류가 발생했습니다. ${common.getResultMessage(result)}`,
            duration: 3000,
          });
        }
      } catch (error: any) {
        console.error("기관 등록 요청 거부 실패:", error);
        notification.error({
          title: "기관 등록 요청 거부 실패",
          content: `기관 등록 요청 거부 중 오류가 발생했습니다: ${error.message || error}`,
          duration: 3000,
        });
      } finally {
        isRejecting.value[org.SK] = false;
      }
    },
  });
}
async function resetOrgAdminPassword(orgSK: string | undefined) {
  if (!orgSK || !selectedOrganization.value) {
    message.error("기관 정보가 올바르지 않습니다.");
    return;
  }

  showActionDialog({
    title: "비밀번호 재설정 확인",
    content: `기관(${selectedOrganization.value.name})의 관리자 비밀번호를 재설정하시겠습니까?\n재설정한 비밀번호는 기관 이메일로 전송됩니다.`,
    positiveText: "확인",
    negativeText: "취소",
    confirmButtonLoadingText: "요청 중...",
    onConfirm: async () => {
      try {
        const result = await resetOrgAdminPasswordCallable({ SK: orgSK });
        if (common.evalFunctionResult(result)) {
          message.success("비밀번호 재설정 요청이 완료되었습니다. 새 비밀번호는 관리자 이메일로 발송됩니다.");
        } else {
          notification.error({
            title: "재설정 오류",
            content: `비밀번호 재설정 중 오류가 발생했습니다. ${common.getResultMessage(result)}`,
            duration: 3000,
          });
        }
      } catch (error: any) {
        console.error("비밀번호 재설정 실패:", error);
        notification.error({
          title: "재설정 실패",
          content: `비밀번호 재설정 중 오류가 발생했습니다: ${error.message || error}`,
          duration: 3000,
        });
      }
    },
  });
}

// 기관 ID 중복 체크 함수
async function checkOrganizationId() {
  if (!registrationModel.value.uid) {
    idCheckMessage.value = "기관 ID를 먼저 입력해주세요.";
    isIdAvailable.value = false;
    return;
  }
  isCheckingId.value = true; // ID 중복 체크 로딩 시작
  idCheckMessage.value = "";
  isIdAvailable.value = null;
  try {
    const result: any = await checkOrgIdCallable({ id: registrationModel.value.uid }); // 파라미터도 uid로
    if (common.evalFunctionResult(result)) {
      const checkResult = common.getItemFromFunctionResult(result);
      if (checkResult) {
        idCheckMessage.value = "이미 사용 중인 ID입니다.";
        isIdAvailable.value = false;
      } else {
        idCheckMessage.value = "사용 가능한 ID입니다.";
        isIdAvailable.value = true;
      }
    } else {
      idCheckMessage.value = "ID 중복 체크 중 오류가 발생했습니다.";
      isIdAvailable.value = false;
    }
  } catch (error: any) {
    console.error("ID 중복 체크 실패:", error);
    idCheckMessage.value = "ID 중복 체크 중 오류가 발생했습니다.";
    isIdAvailable.value = false;
  } finally {
    isCheckingId.value = false; // ID 중복 체크 로딩 종료
  }
}

async function handleUpdateOrganization() {
  if (!editableOrganizationDetails.value.SK) {
    message.error("수정할 기관 정보가 없습니다.");
    return;
  }

  // Basic validation
  if (!editableOrganizationDetails.value.name?.trim()) {
    message.error("기관명은 필수입니다.");
    return;
  }
  if (!editableOrganizationDetails.value.type?.trim()) {
    message.error("기관유형은 필수입니다.");
    return;
  }
  if (!editableOrganizationDetails.value.email?.trim()) {
    message.error("이메일은 필수입니다.");
    return;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (editableOrganizationDetails.value.email && !emailRegex.test(editableOrganizationDetails.value.email)) {
    message.error("올바른 이메일 형식이 아닙니다.");
    return;
  }
  const phoneRegex = /^\d{2,3}-\d{3,4}-\d{4}$/;
  if (
    editableOrganizationDetails.value.phoneNumber &&
    editableOrganizationDetails.value.phoneNumber.trim() !== "" && // Allow empty if optional
    !phoneRegex.test(editableOrganizationDetails.value.phoneNumber)
  ) {
    message.error("전화번호 형식이 올바르지 않습니다. (예: 02-123-4567 또는 010-1234-5678)");
    return;
  }

  isUpdating.value = true;
  try {
    const payload: Partial<Organization> = { ...editableOrganizationDetails.value };

    // Convert empty strings for optional fields to undefined, if backend prefers that
    if (payload.dept === "") payload.dept = undefined;
    if (payload.deptPersonName === "") payload.deptPersonName = undefined;
    if (payload.description === "") payload.description = undefined;
    if (payload.phoneNumber === "") payload.phoneNumber = undefined; // Assuming phoneNumber can be optional

    const result = await updateOrganizationCallable(payload);
    if (common.evalFunctionResult(result)) {
      message.success("기관 정보가 성공적으로 수정되었습니다.");
      showDetailsModal.value = false;
      await wrappedRefreshOrganizations({ status: currentTab.value }); // Refresh the list
    } else {
      notification.error({
        title: "수정 실패",
        content: `기관 정보 수정 중 오류 발생: ${common.getResultError(result) || "알 수 없는 오류"}`,
        duration: 3000,
      });
    }
  } catch (err: any) {
    console.error("기관 정보 수정 실패:", err);
    notification.error({
      title: "수정 실패",
      content: `기관 정보 수정 중 오류 발생: ${err.message || "알 수 없는 오류"}`,
      duration: 3000,
    });
  } finally {
    isUpdating.value = false;
  }
}

async function handleRegistrationSubmit() {
  try {
    await registrationFormRef.value?.validate();
  } catch (errors) {
    message.error("입력 내용을 확인해주세요.");
    return;
  }

  if (isIdAvailable.value !== true) {
    message.error("기관 ID 중복 체크를 통과해야 합니다.");
    return;
  }
  isRegisting.value = true;
  try {
    const result = await createOrganizationCallable(registrationModel.value);
    if (common.evalFunctionResult(result)) {
      message.success("기관 등록 성공!"); // 임시
      showRegistrationForm.value = false;
      wrappedRefreshOrganizations({ status: currentTab.value }); // 목록 새로고침
    } else {
      const errorDetail = common.getResultError(result);
      notification.error({
        title: "등록 에러",
        content: `기관 등록 실패: ${errorDetail ? String(errorDetail) : "오류가 발생했습니다."}`,
        duration: 1500,
        closable: true,
      });
    }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    notification.error({
      title: "에러",
      content: `기관 등록 실패: ${errorMessage || "오류가 발생했습니다."}`,
      duration: 3000,
      closable: true,
    });
  } finally {
    isRegisting.value = false;
    return;
  }
}

function goToRegisterOrganization() {
  selectedOrganization.value = null;
  showRegistrationForm.value = true;
  showDetailsModal.value = false;
  registrationModel.value = {
    uid: "",
    name: "",
    president: "",
    type: "",
    address: {
      postCode: "",
      address: "",
      addressDetail: "",
    },
    dept: "",
    deptPersonName: "",
    deptPersonPhoneNumber: "",
    email: "",
    phoneNumber: "",
    description: "",
  };
  idCheckMessage.value = "";
  isIdAvailable.value = null;
}

async function handleTabChange(tabName: string) {
  organizations.value = [];
  await wrappedRefreshOrganizations({ status: tabName });
}

const openPostcodeSearch = () => {
  if (typeof (window as any).daum === "undefined" || typeof (window as any).daum.Postcode === "undefined") {
    message.error("Daum 우편번호 서비스가 로드되지 않았습니다. 페이지를 새로고침하거나 관리자에게 문의하세요.");
    return;
  }
  new (window as any).daum.Postcode({
    oncomplete: (data: any) => {
      let addr = "";
      let extraAddr = "";

      if (data.userSelectedType === "R") {
        addr = data.roadAddress;
      } else {
        addr = data.jibunAddress;
      }

      if (data.userSelectedType === "R") {
        if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
          extraAddr += data.bname;
        }
        if (data.buildingName !== "" && data.apartment === "Y") {
          extraAddr += extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
        }
        if (extraAddr !== "") {
          extraAddr = " (" + extraAddr + ")";
        }
      }

      if (registrationModel.value.address) {
        registrationModel.value.address.postCode = data.zonecode;
        registrationModel.value.address.address = addr + extraAddr;
      }
      document.getElementById("addressDetailInput")?.focus();
    },
  }).open();
};

// 1. 사용자 관리 모달 열기 및 조회
async function openUserManagementModal(org: Organization) {
  selectedOrgForUserManagement.value = org;
  showUserManagementModal.value = true;
  await fetchOrgMembers();
}

async function fetchOrgMembers() {
  if (!selectedOrgForUserManagement.value) return;
  loadingOrgMembers.value = true;
  try {
    const orgId = selectedOrgForUserManagement.value.SK && selectedOrgForUserManagement.value.SK.includes("#")
      ? selectedOrgForUserManagement.value.SK.split("#")[1]
      : selectedOrgForUserManagement.value.SK;
    
    const result = await getOrgMembersCallable({ orgId });
    orgMembers.value = common.getItemListFromFunctionResult(result) || [];
  } catch (err: any) {
    console.error("기관 멤버 조회 실패:", err);
    message.error("기관 멤버 정보를 불러오는데 실패했습니다.");
    orgMembers.value = [];
  } finally {
    loadingOrgMembers.value = false;
  }
}

// 2. 사용자 추가 모달 열기
function openAddUserForm() {
  if (!selectedOrgForUserManagement.value) return;
  
  const orgId = selectedOrgForUserManagement.value.SK && selectedOrgForUserManagement.value.SK.includes("#")
    ? selectedOrgForUserManagement.value.SK.split("#")[1]
    : selectedOrgForUserManagement.value.SK;

  isEditingUser.value = false;
  userEditFormData.value = {
    orgId: orgId,
    uid: "",
    password: "",
    confirmPassword: "",
    name: "",
    email: "",
    phoneNumber: "",
    role: "",
    position: "",
    description: "",
    type: "user",
  };
  showUserEditModal.value = true;
}

// 3. 사용자 수정 모달 열기
function openEditUserForm(user: any) {
  if (!selectedOrgForUserManagement.value) return;
  
  const orgId = selectedOrgForUserManagement.value.SK && selectedOrgForUserManagement.value.SK.includes("#")
    ? selectedOrgForUserManagement.value.SK.split("#")[1]
    : selectedOrgForUserManagement.value.SK;

  isEditingUser.value = true;
  userEditFormData.value = {
    orgId: orgId,
    uid: user.SK.split("#").pop() || "",
    password: "", // 수정 시에는 사용하지 않음
    confirmPassword: "",
    name: user.name || "",
    email: user.email || "",
    phoneNumber: user.phoneNumber || "",
    role: user.role || "",
    position: user.position || "",
    description: user.description || "",
    type: user.type || "user",
  };
  showUserEditModal.value = true;
}

// 4. 사용자 저장 (추가/수정 통합)
async function handleUserEditSubmit() {
  try {
    await userEditFormRef.value?.validate();
  } catch (errors) {
    return;
  }

  if (isEditingUser.value) {
    // 수정일 경우 경고 고지 및 동의 컨펌
    dialog.warning({
      title: "주의 사항 확인",
      content: "사용자 정보를 수정하더라도 이미 이 사용자가 담당자로 지정된 기존 진단 정보(학급 정보 등)에는 자동으로 반영되지 않습니다.\n기존 진단의 담당자 정보도 함께 업데이트하려면, 해당 진단의 상세 화면에서 '담당자 변경' 기능을 사용하여 재설정해야 합니다.\n\n정말로 이대로 정보를 수정하시겠습니까?",
      positiveText: "예, 수정합니다",
      negativeText: "취소",
      onPositiveClick: async () => {
        await executeUserSave();
      }
    });
  } else {
    // 추가일 경우 즉시 저장 실행
    await executeUserSave();
  }
}

async function executeUserSave() {
  isSavingUser.value = true;
  try {
    let result;
    if (isEditingUser.value) {
      // 수정 API 호출
      result = await updateOrgUserCallable({
        orgId: userEditFormData.value.orgId,
        uid: userEditFormData.value.uid,
        name: userEditFormData.value.name,
        email: userEditFormData.value.email || null,
        phoneNumber: userEditFormData.value.phoneNumber || null,
        role: userEditFormData.value.role || null,
        position: userEditFormData.value.position || null,
        description: userEditFormData.value.description || null,
      });
    } else {
      // 추가 API 호출
      result = await addOrgUserCallable({
        orgId: userEditFormData.value.orgId,
        uid: userEditFormData.value.uid,
        password: userEditFormData.value.password,
        name: userEditFormData.value.name,
        email: userEditFormData.value.email || null,
        phoneNumber: userEditFormData.value.phoneNumber || null,
        role: userEditFormData.value.role || null,
        position: userEditFormData.value.position || null,
        description: userEditFormData.value.description || null,
        type: userEditFormData.value.type,
      });
    }

    if (common.evalFunctionResult(result)) {
      notification.success({
        title: "성공",
        description: isEditingUser.value ? "사용자 정보가 수정되었습니다." : "사용자가 추가되었습니다.",
        duration: 2000,
      });
      showUserEditModal.value = false;
      await fetchOrgMembers(); // 목록 새로고침
    } else {
      notification.error({
        title: "실패",
        description: common.getResultError(result) || "처리에 실패했습니다.",
        duration: 3000,
      });
    }
  } catch (err: any) {
    console.error("사용자 저장 실패:", err);
    notification.error({
      title: "에러",
      description: "오류가 발생했습니다.",
      duration: 3000,
    });
  } finally {
    isSavingUser.value = false;
  }
}

// 5. 사용자 삭제
function handleDeleteUser(user: any) {
  const userId = user.SK.split("#").pop() || "";
  dialog.warning({
    title: "사용자 삭제",
    content: `정말로 사용자 [${userId}] (이름: ${user.name || "N/A"}) 계정을 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.`,
    positiveText: "삭제",
    negativeText: "취소",
    onPositiveClick: async () => {
      try {
        const orgId = selectedOrgForUserManagement.value!.SK && selectedOrgForUserManagement.value!.SK.includes("#")
          ? selectedOrgForUserManagement.value!.SK.split("#")[1]
          : selectedOrgForUserManagement.value!.SK;
          
        const result = await deleteOrgUserMemberCallable({
          orgId: orgId,
          uid: userId,
        });

        if (common.evalFunctionResult(result)) {
          notification.success({
            title: "성공",
            description: "사용자가 삭제되었습니다.",
            duration: 2000,
          });
          await fetchOrgMembers(); // 목록 새로고침
        } else {
          notification.error({
            title: "실패",
            description: common.getResultError(result) || "사용자 삭제에 실패했습니다.",
            duration: 3000,
          });
        }
      } catch (err: any) {
        console.error("사용자 삭제 실패:", err);
        notification.error({
          title: "에러",
          description: "오류가 발생했습니다.",
          duration: 3000,
        });
      }
    }
  });
}

onMounted(() => {

  wrappedRefreshOrganizations({ status: currentTab.value });
});
</script>

<style scoped>
.registration-form-content p {
  margin: 8px 0;
  line-height: 1.6;
  color: #333; /* 모달 내부 텍스트 색상 명확히 */
}

.description-item-label-fixed-width {
  width: 100px; /* "기관 ID" 레이블과 유사한 너비로 조정 */
  display: inline-block; /* 너비 적용을 위해 */
}
.description-item-content-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
:deep(.n-form-item-feedback-wrapper:empty) {
  display: none;
}
.table-container {
  width: 100%; /* 부모 요소의 너비를 최대한 활용 */
  overflow-x: auto; /* 내용이 넘칠 경우 가로 스크롤바 표시 */
}
.force-black-text-disabled.n-input--disabled :deep(.n-input__input-el) {
  color: #000000 !important; /* 검은색으로 설정 */
  -webkit-text-fill-color: #000000 !important; /* WebKit 브라우저 호환성 */
  opacity: 1 !important; /* 비활성화 시 텍스트 투명도 제거 */
}

.registration-modal-content-scrollable {
  max-height: 70vh; /* 필요에 따라 높이 조절 */
  overflow-y: auto;
  padding-right: 15px; /* 스크롤바 공간 확보 */
}
</style>
